module.exports = __webpack_public_path__ + "static/media/cc_icon-jcb.6d6ccfd2.svg";